<template>
  <div>
    <div v-if="transaction && transaction.api_result">
      <div class="border">
        <h4>Договор # {{ transaction.exchange_additional_id }}</h4>

        <div>
          <label>ФИО (договор)</label>
          <h5 class="text-uppercase m-0">
            {{ transaction.api_result.paymart_client.fio }}
          </h5>
          <label>ФИО (представился)</label>
          <h5 class="text-uppercase m-0">
            {{ order.client.full_name }}
          </h5>
          <label>Номер телефона</label>
          <h5 class="text-uppercase m-0">
            {{ order.client.phone }}
          </h5>
        </div>

        <h4>Товары</h4>
        <table class="table border w-100">
          <thead>
            <tr>
              <td><b>Товар</b></td>
              <td align="right"><b>Цена</b></td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(cart, index) in transaction.api_result.cart"
              :key="index"
            >
              <td>
                {{ cart.name }} ✕ {{ cart.amount }}
                <span v-if="cart.imei" class="text-info">
                  {{ cart.imei }}
                </span>
              </td>
              <td align="right">{{ cart.price }} UZS</td>
            </tr>
          </tbody>
        </table>
        <div>
          <h4>
            {{
              transaction.api_result.paymart_client.price_month
                | spaceBetweenNumber
            }}
            UZS / {{ "mo" | setText }}
          </h4>
        </div>
        <div>
          <a
            class="btn btn-info mw mb-3"
            :href="transaction.pre_api_result.client_act_pdf"
            target="_blank"
            >Смотреть договор</a
          >
        </div>
      </div>

      <div class="border">
        <!-- <h4>1. Загрузить подписанный договор</h4>

        <zip-upload
          v-model="act"
          :title="'Выберите PNG/JPG/PDF'"
          :titleKey="'choose_png_jpg'"
          @input="uploadAct"
        />

        <a
          v-if="transaction['act']"
          class="btn btn-sm"
          target="_blank"
          :href="`${transaction['act']}`"
          >{{ "download" | setText("Скачать") }}</a
        > -->

        <h4>Загрузить фото с клиентом и товаром</h4>

        <zip-upload
          v-model="photo"
          :title="'Выберите PNG/JPG/PDF'"
          :titleKey="'choose_png_jpg'"
          @input="uploadPhoto"
        />
        <a
          v-if="transaction['client_product']"
          class="btn btn-sm"
          target="_blank"
          :href="`${transaction['client_product']}`"
          >{{ "donwload" | setText("Скачать") }}</a
        >

        <div
          :class="`mt-4 ${
            transaction['client_product'] ? '' : 'opacity'
          }`"
        >
          <hr />
          <button @click="$emit('setStep', null)" class="btn btn-info mw">
            Продолжить
          </button>
        </div>
      </div>

      <div class="border" v-if="$store.state.user.is_root">
        <h4>Отмена заказа</h4>
        <button class="btn btn-danger mw mb-3" @click="cancel" target="_blank">
          Отменить договор
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";
export default {
  computed: {},
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    createTransaction: {
      default: function () {},
    },
    transaction: {
      default: function () {},
    },
    value: {
      default: null,
    },
  },
  async created() {},
  methods: {
    async uploadPhoto() {
      let bodyFormData = new FormData();
      bodyFormData.append("id", this.transaction["exchange_additional_id"]);
      bodyFormData.append("client_photo", this.photo);
      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}v1/contracts/upload-client-photo?company_id=${this.partner.api_public_key}`,
        method: "POST",
        data: bodyFormData,
        headers: {
          Authorization: `Bearer ${this.partner["api_secret_key"]}`,
          "Content-Type": "multipart/form-data",
        },
      })
        .then(async (response) => {
          await this.createTransaction({
            client_product: this.photo,
          });
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
          this.$loading(false);
        })
        .finally(() => {});
    },
    async uploadAct() {
      let bodyFormData = new FormData();
      bodyFormData.append("id", this.transaction["exchange_id"]);
      bodyFormData.append("act", this.act);
      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}v1/contracts/upload/act?company_id=${this.partner.api_public_key}`,
        method: "POST",
        data: bodyFormData,
        headers: {
          Authorization: `Bearer ${this.partner["api_secret_key"]}`,
          "Content-Type": "multipart/form-data",
        },
      })
        .then(async (response) => {
          await this.createTransaction({
            akt_uploaded: 1,
            akt: this.act,
          });
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
          this.$loading(false);
        })
        .finally(() => {});
    },
    async cancel() {
      this.$loading(true);
      let data = {
        contract_id: this.transaction.exchange_id,
        buyer_phone: this.order.client.phone,
      };
      this.$http
        .post(
          `${this.partner["endpoint_url"]}v1/buyers/credit/cancel?company_id=${this.partner.api_public_key}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${this.partner["api_secret_key"]}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then(async (response) => {
          const rData = response.data;
          if (
            (rData.result && rData.result.status == 1) ||
            (rData.status && rData.status == 1)
          ) {
            await this.createTransaction({
              client_confirmed: 0,
              system_confirmed: 0,
              status: "-1",
            });
          } else {
            this.$loading(false);
            this.$notify({
              title: "UZUM NASIYA",
              message: response.data.error,
              type: "danger",
            });
          }
        })
        .catch((error) => {
          this.$loading(false);
          errorNotify(error, this.$notify);
        })
        .finally(() => {});
    },
  },
  data() {
    return {
      act: null,
      photo: null,
    };
  },
};
</script>



